<template>
  <div class="wc-layout wc-layout--mobile-default">
    <WCMobileHeaderV2 class="mobile-header" />
    <div class="wc-layout__body container-fluid px-0">
      <router-view />
    </div>
  </div>
</template>

<script>
import WCMobileHeaderV2 from '@/components/WCMobileHeaderV2/WCMobileHeaderV2.vue';
import MobileHeaderHeightMixin from '@/mixins/MobileHeaderHeightMixin';

export default {
  name: 'MobileScanView',
  components: {
    WCMobileHeaderV2,
  },
  mixins: [MobileHeaderHeightMixin],
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-layout--mobile-headerless {
  .wc-layout__body {
    padding-bottom: $pad-3 * 3.7;
  }
}
</style>
